import React, { useEffect } from 'react'
import { View, Text } from "@react-pdf/renderer";
import { insertPDFNewlines, logger } from '../../../../../utils';

const TableRow = ({ summary }) => {

    const groupByItemNumber = (data) => {
        return data.reduce((acc, item) => {
            const key = item.item_number;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
            return acc;
        }, {});
    }

    const groupedData = groupByItemNumber(summary.job_order_meta_summary_measure);

    useEffect(() => {
        // console.log(`Grouped_Data: `, groupedData);
    }, [groupedData]);

    // const number_of_rows = summary.inspected_measure_check_quantity;
    const number_of_rows = 5;

    // Create an empty array with length equal to number_of_rows
    const numOfRows = Array.from({ length: number_of_rows }, (_, index) => index);

    return (
        numOfRows.map((i, index) => {
            const items = groupedData[index] || [];
            
            return (
                <View
                    key={index}
                    style={{
                        flexDirection: "row",
                        padding: "0px 10px"
                    }}
                >

                    <View
                        style={{
                            width: "100%",
                            flexDirection: "row"
                        }}
                    >
                        {/* ITEM */}
                        <View
                            style={{
                                backgroundColor: "#fff",
                                padding: "1px",
                                width: "8%",
                                borderWidth: "1px",
                                borderTopWidth: "0",
                                borderColor: "#000",
                                borderRightWidth: "0px",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: "7px",
                                    color: "#000",
                                    textAlign: "center"
                                }}
                            >
                                {index}
                                {/* {item.item_number} */}
                            </Text>
                        </View>
                        {/* ITEM */}

                        {/* MEASURE */}
                        <View
                            style={{
                                backgroundColor: "#fff",
                                padding: "1px",
                                width: "24%",
                                borderWidth: "1px",
                                borderTopWidth: "0",
                                borderColor: "#000",
                                borderRightWidth: "0px",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            {
                                (items && items.length > 0) ?
                                    items.map((item, i) => {
                                        return (
                                            <Text
                                                style={{
                                                    fontSize: "7px",
                                                    color: "#000",
                                                    textAlign: "center"
                                                }}
                                            >
                                                {item.pom ? item.pom : "-"}
                                            </Text>
                                        )
                                    })

                                    :
                                    <Text
                                        style={{
                                            fontSize: "7px",
                                            color: "#000",
                                            textAlign: "center"
                                        }}
                                    >
                                        -
                                    </Text>
                            }
                        </View>
                        {/* MEASURE */}

                        {/* CRITICAL */}
                        <View
                            style={{
                                backgroundColor: "#fff",
                                padding: "1px",
                                width: "24%",
                                borderWidth: "1px",
                                borderTopWidth: "0",
                                borderColor: "#000",
                                borderRightWidth: "0px",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            {
                                (items && items.length > 0) ?
                                    items.map((item, i) => {
                                        return (
                                            <Text
                                                style={{
                                                    fontSize: "7px",
                                                    color: "#000",
                                                    textAlign: "center"
                                                }}
                                            >
                                                {item.pom ? "Critical" : "-"}
                                            </Text>
                                        )
                                    })

                                    :
                                    <Text
                                        style={{
                                            fontSize: "7px",
                                            color: "#000",
                                            textAlign: "center"
                                        }}
                                    >
                                        -
                                    </Text>
                            }
                        </View>
                        {/* CRITICAL */}

                        {/* OFFSET */}
                        <View
                            style={{
                                backgroundColor: "#fff",
                                padding: "1px",
                                width: "24%",
                                borderWidth: "1px",
                                borderTopWidth: "0",
                                borderColor: "#000",
                                borderRightWidth: "0px",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            {
                                (items && items.length > 0) ?
                                    items.map((item, i) => {
                                        return (
                                            <Text
                                                style={{
                                                    fontSize: "7px",
                                                    color: "#000",
                                                    textAlign: "center"
                                                }}
                                            >
                                                {item.offSet_value ? item.offSet_value.toFixed(2) : "-"}
                                            </Text>
                                        )
                                    })

                                    :
                                    <Text
                                        style={{
                                            fontSize: "7px",
                                            color: "#000",
                                            textAlign: "center"
                                        }}
                                    >
                                        -
                                    </Text>
                            }
                        </View>
                        {/* OFFSET */}

                        {/* NOTE */}
                        <View
                            style={{
                                backgroundColor: "#fff",
                                padding: "1px",
                                width: "12%",
                                borderWidth: "1px",
                                borderTopWidth: "0",
                                borderColor: "#000",
                                borderRightWidth: "0px",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            {
                                (items && items.length > 0) ?
                                    items.map((item, i) => {
                                        return (
                                            <Text
                                                style={{
                                                    fontSize: "7px",
                                                    color: "#000",
                                                    textAlign: "center"
                                                }}
                                            >
                                                {item.checkerNote ? item.checkerNote : "-"}
                                            </Text>
                                        )
                                    })

                                    :
                                    <Text
                                        style={{
                                            fontSize: "7px",
                                            color: "#000",
                                            textAlign: "center"
                                        }}
                                    >
                                        -
                                    </Text>
                            }
                        </View>
                        {/* NOTE */}

                        {/* PIC */}
                        <View
                            style={{
                                backgroundColor: "#fff",
                                padding: "1px",
                                width: "8%",
                                borderWidth: "1px",
                                borderTopWidth: "0",
                                borderColor: "#000",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: "7px",
                                    color: "#000",
                                    textAlign: "center",
                                    flexWrap: "wrap",
                                    textOverflow: "ellipsis"
                                }}
                            >
                                -
                                {/* {insertPDFNewlines("Hello world this is me some_pic_123331.jpg", 10)} */}
                            </Text>
                        </View>
                        {/* PIC */}
                    </View>
                </View >
            )
        })
    )
}

export default TableRow